import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { Mutation } from '@/graphql/API';
import { passwordReset } from '@/graphql/mutations';
import type { OperationVariables } from '@apollo/client/core';
import type { UseMutationReturn } from '@vue/apollo-composable';

const document = gql(passwordReset);

type MutationResult = {
  passwordReset: Mutation['passwordReset'];
};

export function usePasswordReset(): UseMutationReturn<
  MutationResult,
  OperationVariables
> {
  return useMutation<MutationResult>(document);
}
